// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { APP_CONFIG } from "./config";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: APP_CONFIG.apiKey,
  authDomain: APP_CONFIG.authDomain,
  projectId: APP_CONFIG.projectId,
  storageBucket: APP_CONFIG.storageBucket,
  messagingSenderId: APP_CONFIG.messagingSenderId,
  appId: APP_CONFIG.appId,
  measurementId: APP_CONFIG.measurementId,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
